import store from '../store'
import * as UserApi from '../api/user'

export const permissionGuard = (to, from, next) => {
  const haveReadPermission = store.getters.userHaveReadPermission

  if (haveReadPermission) {
    next()
  } else {
    next('/page-not-found')
  }
}

export const isKauLogin = async (to, from, next) => {
  const userLoginStrategy = await UserApi.getAuthStrategy()

  if (userLoginStrategy === 'kau-login') {
    next()
  } else {
    next('/page-not-allowed')
  }
}
